export const ADMIN_AUTH = {
  userPoolId: process.env.REACT_APP_ADMIN_USER_POOL_ID || "",
  userPoolClientId: process.env.REACT_APP_ADMIN_USER_POOL_CLIENT_ID || "",

};

export const isAdminConfigured = () => Boolean(ADMIN_AUTH.userPoolId && ADMIN_AUTH.userPoolClientId);

export function isAdminSession(session) {
  const claims = session?.tokens?.idToken?.payload;
  const region = ADMIN_AUTH.userPoolId.split("_")[0];
  return Boolean(isAdminConfigured() && claims &&
    claims.iss === `https://cognito-idp.${region}.amazonaws.com/${ADMIN_AUTH.userPoolId}` &&
    claims.aud === ADMIN_AUTH.userPoolClientId && claims.token_use === "id" &&
    claims.exp > Date.now() / 1000 && claims.email_verified === true &&
    typeof claims.email === "string" && Array.isArray(claims["cognito:groups"]) &&
    claims["cognito:groups"].includes("Administrators"));
}

export function safeAdminReturn(value) {
  const fallback = "/admin/dashboard";
  if (typeof value !== "string" || !value.startsWith("/admin/") ||
      value.includes("\\") || /[%\s]/.test(value)) return fallback;
  try {
    const url = new URL(value, "https://bookishcircle.com");
    const routes = ["/admin/dashboard", "/admin/social-drafts", "/admin/mail-center", "/admin/featured-books", "/admin/promotions", "/admin/quests"];
    return routes.includes(url.pathname) ? url.pathname + url.search + url.hash : fallback;
  } catch { return fallback; }
}
